import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=7fa84772&"
import script from "./Collection.js?vue&type=script&lang=js&"
export * from "./Collection.js?vue&type=script&lang=js&"
import style0 from "./Collection.vue?vue&type=style&index=0&id=7fa84772&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports